import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { GetASupplierUserResponse } from "../../../models/supplierUserBarnch.model";

interface Props {
  getASupplierUserResponse: GetASupplierUserResponse;
}

const UserBranchHeader = ({ getASupplierUserResponse }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      boxShadow={"0px 1px 1px rgba(0,0,0,0.16)"}
      flexDirection={"column"}
      height={"100%"}
      padding={2}
    >
      <Grid
        item
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        flexDirection={isMobile ? "column" : "row"}
      >
        {/* اطلاعات پروفایل */}
        <Grid item sx={{ display: "flex", alignItems: "center" }}>
          <AccountCircleIcon
            sx={{
              color: "#9AAFC4",
              fontSize: 60,
              marginLeft: "10px",
            }}
          />
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
              {getASupplierUserResponse?.fullName}
            </b>
          </Typography>
        </Grid>

        {/* کد ملی */}
        <Grid item>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
              کد ملی: {getASupplierUserResponse?.nationalCode}
            </b>
          </Typography>
        </Grid>

        {/* شماره موبایل */}
        <Grid item>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
              شماره موبایل: {getASupplierUserResponse?.mobileNumber}
            </b>
          </Typography>
        </Grid>

        {/* تاریخ تولد */}
        <Grid item>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
              تاریخ تولد: {getASupplierUserResponse?.birthDate_Persian}
            </b>
          </Typography>
        </Grid>

        {/* وضعیت */}
        <Grid item>
          {getASupplierUserResponse?.isActiveTitle === "فعال" ? (
            <Typography
              sx={{
                color: "#28A745",
                background: "#E5F7EC",
                padding: "5px 10px",
                borderRadius: "5px",
                fontWeight: 600,
                minWidth: "80px",
                textAlign: "center",
              }}
            >
              کاربر فعال
            </Typography>
          ) : (
            <Typography
              sx={{
                color: "#EC0F34",
                background: "#F8B6C1",
                padding: "5px 10px",
                borderRadius: "5px",
                fontWeight: 600,
                minWidth: "100px",
                textAlign: "center",
              }}
            >
              کاربر غیرفعال
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserBranchHeader;
